module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-tgcom.a677e17b73cccf10cc0e773d0a0b4287.png";